<template>
  <button class="btn btn-default btn-small" @click="toTour">3Д - Тур</button>
</template>

<script>
export default {
  props: {
    tourRender: {
      type: String,
      default: "",
    },
  },
  methods: {
    toTour() {
      this.$vfm.show({
        component: "PopupPanorama",
        bind: {
          title: "3Д-тур",
          src: this.tourRender,
        },
      });
    },
  },
};
</script>

<style scoped>
.btn-small {
  width: 126px;
  height: 48px;
  padding: 10px 24px;
}
</style>
